export default __webpack_public_path__ + "static/media/check.5dfa6ed6.svg";